"use client";
import { Check, Copy } from "lucide-react";
import type React from "react";
import { useCopyToClipboard } from "../hooks/use-copy-to-clipboard";

interface CopyButtonProps {
  text: string;
  className?: string;
}

export const CopyButton: React.FC<CopyButtonProps> = ({
  text,
  className = "",
}) => {
  const { isCopied, copyToClipboard } = useCopyToClipboard({});

  return (
    <button
      type="button"
      onClick={() => copyToClipboard(text)}
      className={`rounded p-1 hover:bg-gray-100 dark:hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:focus:ring-gray-600 ${className}`}
      title="Copy to clipboard"
    >
      {isCopied ? (
        <div className="flex items-center">
          <Check className="h-4 w-4 text-green-500" />
        </div>
      ) : (
        <Copy className="h-4 w-4 text-gray-500" />
      )}
    </button>
  );
};
